// src/components/Categories.js

export const signCategories = [
  {
    id: 1,
    name: "Banner - Economy Vinyl",
    price: 0,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000179/custom-vinyl-banner-catholic-university-500.jpg",
    brief: "Economy grade indoor/outdoor vinyl banner",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select Size",
        options: [
          {
            name: "24W x 48H",
            price: 15.95,
            width: 24,
            height: 48,
            code: "24x48",
          },
          {
            name: "48W x 24H",
            price: 15.95,
            width: 48,
            height: 24,
            code: "48x24",
          },
          {
            name: "36W x 24H",
            price: 15.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "48W x 48H",
            price: 31.95,
            width: 48,
            height: 48,
            code: "48x48",
          },
          {
            name: "60W x 36H",
            price: 29.95,
            width: 60,
            height: 36,
            code: "60x36",
          },
          {
            name: "72W x 24H",
            price: 23.95,
            width: 72,
            height: 24,
            code: "72x24",
          },
          {
            name: "72W x 36H",
            price: 35.95,
            width: 72,
            height: 54,
            code: "72x36",
          },
          {
            name: "72W x 48H",
            price: 36.95,
            width: 72,
            height: 48,
            code: "72x48",
          },
          {
            name: "96W x 24H",
            price: 31.95,
            width: 96,
            height: 24,
            code: "96x24",
          },
          {
            name: "96W x 36H",
            price: 47.95,
            width: 96,
            height: 36,
            code: "96x36",
          },
          {
            name: "96W x 48H",
            price: 63.95,
            width: 96,
            height: 48,
            code: "96x48",
          },
          {
            name: "120W x 48H",
            price: 79.95,
            width: 120,
            height: 48,
            code: "120x48",
          },
          {
            name: "120W x 60H",
            price: 99.95,
            width: 120,
            height: 60,
            code: "120x60",
          },
          {
            name: "180W x 48H",
            price: 118.95,
            width: 180,
            height: 48,
            code: "180x48",
          },
          {
            name: "240W x 60H",
            price: 198.95,
            width: 240,
            height: 60,
            code: "240x60",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select Thickness",
        options: [
          {
            name: "13 oz",
            price: 0,
            code: "13_oz",
          },
        ],
      },
      addOns: {
        code: "options",
        prompt: "Select Add-Ons",
        options: [
          {
            name: "Welded",
            price: 0,
            code: "welded",
          },
          {
            name: "Grommets",
            price: 1,
            code: "grommets",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS0101",
  },
  {
    id: 35,
    name: "Banner - Heavy 18oz Vinyl",
    price: 0,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000179/custom-vinyl-banner-catholic-university-500.jpg",
    brief: "Heavy duty grade indoor/outdoor vinyl banner",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select Size",
        options: [
          {
            name: "24W x 48H",
            price: 26.95,
            width: 24,
            height: 48,
            code: "24x48",
          },
          {
            name: "48W x 24H",
            price: 26.95,
            width: 48,
            height: 24,
            code: "48x24",
          },
          {
            name: "36W x 24H",
            price: 19.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "48W x 48H",
            price: 52.95,
            width: 48,
            height: 48,
            code: "48x48",
          },
          {
            name: "60W x 36H",
            price: 49.95,
            width: 60,
            height: 36,
            code: "60x36",
          },
          {
            name: "72W x 24H",
            price: 39.95,
            width: 72,
            height: 24,
            code: "72x24",
          },
          {
            name: "72W x 36H",
            price: 65.95,
            width: 72,
            height: 54,
            code: "72x36",
          },
          {
            name: "72W x 48H",
            price: 79.95,
            width: 72,
            height: 48,
            code: "72x48",
          },
          {
            name: "96W x 24H",
            price: 52.95,
            width: 96,
            height: 24,
            code: "96x24",
          },
          {
            name: "96W x 36H",
            price: 79.95,
            width: 96,
            height: 36,
            code: "96x36",
          },
          {
            name: "96W x 48H",
            price: 105.95,
            width: 96,
            height: 48,
            code: "96x48",
          },
          {
            name: "120W x 48H",
            price: 132.95,
            width: 120,
            height: 48,
            code: "120x48",
          },
          {
            name: "120W x 60H",
            price: 165.95,
            width: 120,
            height: 60,
            code: "120x60",
          },
          {
            name: "180W x 48H",
            price: 198.95,
            width: 180,
            height: 48,
            code: "180x48",
          },
          {
            name: "240W x 60H",
            price: 329.95,
            width: 240,
            height: 60,
            code: "240x60",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select Thickness",
        options: [
          {
            name: "18 oz",
            price: 0,
            code: "18_oz",
          },
        ],
      },
      addOns: {
        code: "options",
        prompt: "Select Add-Ons",
        options: [
          {
            name: "Welded",
            price: 0,
            code: "welded",
          },
          {
            name: "Grommets",
            price: 1,
            code: "grommets",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS0105",
  },
  {
    id: 2,
    name: "Banner - Doublesided",
    price: 0,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000179/banner_doublesided_50x50-01.jpg",
    brief: "Printed double sided with sun block material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select Size",
        options: [
          {
            name: "24W x 48H",
            price: 31.95,
            width: 24,
            height: 48,
            code: "24x48",
          },
          {
            name: "48W x 24H",
            price: 31.95,
            width: 48,
            height: 24,
            code: "48x24",
          },
          {
            name: "36W x 24H",
            price: 29.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "48W x 48H",
            price: 62.95,
            width: 48,
            height: 48,
            code: "48x48",
          },
          {
            name: "60W x 36H",
            price: 59.95,
            width: 60,
            height: 36,
            code: "60x36",
          },
          {
            name: "72W x 24H",
            price: 47.95,
            width: 72,
            height: 24,
            code: "72x24",
          },
          {
            name: "72W x 36H",
            price: 71.95,
            width: 72,
            height: 54,
            code: "72x36",
          },
          {
            name: "72W x 48H",
            price: 94.95,
            width: 72,
            height: 48,
            code: "72x48",
          },
          {
            name: "96W x 24H",
            price: 62.95,
            width: 96,
            height: 24,
            code: "96x24",
          },
          {
            name: "96W x 36H",
            price: 94.95,
            width: 96,
            height: 36,
            code: "96x36",
          },
          {
            name: "96W x 48H",
            price: 126.95,
            width: 96,
            height: 48,
            code: "96x48",
          },
          {
            name: "120W x 48H",
            price: 158.95,
            width: 120,
            height: 48,
            code: "120x48",
          },
          {
            name: "120W x 60H",
            price: 198.95,
            width: 120,
            height: 60,
            code: "120x60",
          },
          {
            name: "180W x 48H",
            price: 237.95,
            width: 180,
            height: 48,
            code: "180x48",
          },
          {
            name: "240W x 60H",
            price: 396.95,
            width: 240,
            height: 60,
            code: "240x60",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "18oz",
            price: 0,
            code: "18_oz",
          },
        ],
      },
      addOns: {
        code: "finish",
        prompt: "Select finish",
        options: [
          {
            name: "Welded",
            price: 0,
            code: "welded",
          },
          {
            name: "Grommets",
            price: 1,
            code: "grommets",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS0102",
  },
  {
    id: 3,
    name: "Banner - Mesh",
    price: 0,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000179/mesh-banner-500_50x50.jpg",
    brief: "Mesh banner material for windy conditions",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select Size",
        options: [
          {
            name: "24W x 48H",
            price: 17.95,
            width: 24,
            height: 48,
            code: "24x48",
          },
          {
            name: "48W x 24H",
            price: 19.95,
            width: 48,
            height: 24,
            code: "48x24",
          },
          {
            name: "36W x 24H",
            price: 15.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "48W x 48H",
            price: 35.95,
            width: 48,
            height: 48,
            code: "48x48",
          },
          {
            name: "60W x 36H",
            price: 32.95,
            width: 60,
            height: 36,
            code: "60x36",
          },
          {
            name: "72W x 24H",
            price: 26.95,
            width: 72,
            height: 24,
            code: "72x24",
          },
          {
            name: "72W x 36H",
            price: 39.95,
            width: 72,
            height: 54,
            code: "72x36",
          },
          {
            name: "72W x 48H",
            price: 52.95,
            width: 72,
            height: 48,
            code: "72x48",
          },
          {
            name: "96W x 24H",
            price: 35.95,
            width: 96,
            height: 24,
            code: "96x24",
          },
          {
            name: "96W x 36H",
            price: 52.95,
            width: 96,
            height: 36,
            code: "96x36",
          },
          {
            name: "96W x 48H",
            price: 69.95,
            width: 96,
            height: 48,
            code: "96x48",
          },
          {
            name: "120W x 48H",
            price: 87.95,
            width: 120,
            height: 48,
            code: "120x48",
          },
          {
            name: "120W x 60H",
            price: 109.95,
            width: 120,
            height: 60,
            code: "120x60",
          },
          {
            name: "180W x 48H",
            price: 132.95,
            width: 180,
            height: 48,
            code: "180x48",
          },
          {
            name: "240W x 60H",
            price: 219.95,
            width: 240,
            height: 60,
            code: "240x60",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "10oz",
            price: 0,
            code: "10_oz",
          },
        ],
      },
      addOns: {
        code: "finish",
        prompt: "Select finish",
        options: [
          {
            name: "Sealed edge",
            price: 0,
            code: "welded",
          },
          {
            name: "Grommets",
            price: 1,
            code: "grommets",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "BN1005",
  },
  {
    id: 4,
    name: "Banner - Tear Resistant",
    price: 0,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000179/tear-resistant-banner-500_50x50.jpg",
    brief: "Tear resistant banner material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "24W x 48H",
            price: 21.95,
            width: 24,
            height: 48,
            code: "24x48",
          },
          {
            name: "48W x 24H",
            price: 21.95,
            width: 48,
            height: 24,
            code: "48x24",
          },
          {
            name: "36W x 24H",
            price: 16.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "48W x 48H",
            price: 43.95,
            width: 48,
            height: 48,
            code: "48x48",
          },
          {
            name: "60W x 36H",
            price: 39.95,
            width: 60,
            height: 36,
            code: "60x36",
          },
          {
            name: "72W x 24H",
            price: 32.95,
            width: 72,
            height: 24,
            code: "72x24",
          },
          {
            name: "72W x 36H",
            price: 49.95,
            width: 72,
            height: 36,
            code: "72x36",
          },
          {
            name: "72W x 48H",
            price: 65.95,
            width: 72,
            height: 48,
            code: "72x48",
          },
          {
            name: "96W x 24H",
            price: 43.95,
            width: 96,
            height: 24,
            code: "96x24",
          },
          {
            name: "96W x 36H",
            price: 65.95,
            width: 96,
            height: 36,
            code: "96x36",
          },
          {
            name: "96W x 48H",
            price: 87.95,
            width: 96,
            height: 48,
            code: "96x48",
          },
          {
            name: "120W x 48H",
            price: 109.95,
            width: 120,
            height: 48,
            code: "120x48",
          },
          {
            name: "180W x 48H",
            price: 163.95,
            width: 180,
            height: 48,
            code: "180x48",
          },
          {
            name: "240W x 48H",
            price: 218.95,
            width: 240,
            height: 48,
            code: "240x48",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "5 mil",
            price: 0,
            code: "5_mil",
          },
        ],
      },
      addOns: {
        code: "finish",
        prompt: "Select finish",
        options: [
          {
            name: "Unfinished",
            price: 0,
            code: "unfinished",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "BN1003",
  },
  {
    id: 5,
    name: "Banner - Canvas",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000179/canvas-banner-500_50x50.jpg",
    brief: "Art like textured canvas material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "8W x 10H",
            price: 18.95,
            width: 8,
            height: 10,
            code: "8x10",
          },
          {
            name: "11W x 14H",
            price: 21.95,
            width: 11,
            height: 14,
            code: "11x14",
          },
          {
            name: "12W x 16H",
            price: 23.95,
            width: 12,
            height: 16,
            code: "12x16",
          },
          {
            name: "12W x 18H",
            price: 24.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "16W x 20H",
            price: 28.95,
            width: 16,
            height: 20,
            code: "16x20",
          },
          {
            name: "16W x 24H",
            price: 31.95,
            width: 16,
            height: 24,
            code: "16x24",
          },
          {
            name: "18W x 24H",
            price: 33.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 36H",
            price: 47.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "32W x 48H",
            price: 67.95,
            width: 32,
            height: 48,
            code: "32x48",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "11 oz Canvas Wrapped on Wood Frame",
            price: 0,
            code: "11_oz",
          },
        ],
      },
      addOns: {
        code: "options",
        prompt: "Select options",
        options: [
          {
            name: "Black sides",
            price: 0,
            code: "black_sides",
          },
          {
            name: "White sides",
            price: 0,
            code: "white_sides",
          },
          {
            name: "Folded sides",
            price: 0,
            code: "folded_sides",
          },
          {
            name: "Mirrored sides",
            price: 0,
            code: "mirrored_sides",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "BN1004",
    price: 0,
  },
  {
    id: 6,
    name: "Banner - Fabric",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000217/fabric_banner_v1_50x50.jpg",
    brief: "Fine art like fabric material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "24W x 48H",
            price: 31.95,
            width: 24,
            height: 48,
            code: "24x48",
          },
          {
            name: "48W x 24H",
            price: 31.95,
            width: 48,
            height: 24,
            code: "48x24",
          },
          {
            name: "36W x 24H",
            price: 23.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "48W x 48H",
            price: 63.95,
            width: 48,
            height: 48,
            code: "48x48",
          },
          {
            name: "60W x 36H",
            price: 59.95,
            width: 60,
            height: 36,
            code: "60x36",
          },
          {
            name: "72W x 36H",
            price: 71.95,
            width: 72,
            height: 36,
            code: "72x36",
          },
          {
            name: "72W x 48H",
            price: 95.95,
            width: 72,
            height: 48,
            code: "72x48",
          },
          {
            name: "96W x 36H",
            price: 95.95,
            width: 96,
            height: 36,
            code: "96x36",
          },
          {
            name: "96W x 48H",
            price: 198.95,
            width: 96,
            height: 48,
            code: "96x48",
          },
          {
            name: "96W x 60H",
            price: 159.95,
            width: 96,
            height: 60,
            code: "96x60",
          },
          {
            name: "96W x 72H",
            price: 191.95,
            width: 96,
            height: 72,
            code: "96x72",
          },
          {
            name: "96W x 96H",
            price: 255.95,
            width: 96,
            height: 96,
            code: "96x96",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "9 oz",
            price: 0,
            code: "9_oz",
          },
        ],
      },
      addOns: {
        code: "finish",
        prompt: "Select finish",
        options: [
          {
            name: "Unfinished",
            price: 0,
            code: "unfinished",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "BN1006",
    price: 0,
  },
  {
    id: 7,
    name: "Banner - Step and Repeat",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000179/banner_step_repeat_v1_50x50-01.jpg",
    brief: "Trade show backdrop of repeated logos",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "96W x 96H",
            price: 192,
            width: 96,
            height: 96,
            code: "96x96",
          },
          {
            name: "108W x 96H",
            price: 216,
            width: 108,
            height: 96,
            code: "108x96",
          },
          {
            name: "120W x 96H",
            price: 240,
            width: 120,
            height: 96,
            code: "120x96",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "9 oz",
            price: 0,
            code: "9_oz",
          },
        ],
      },
      addOns: {
        code: "options",
        prompt: "Select option",
        options: [
          {
            name: "Banner Only",
            price: 0,
            code: "graphics",
          },
          {
            name: "Banner and Frame",
            price: 98,
            code: "graphics_frame",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "BN1007",
    price: 0,
  },
  {
    id: 23,
    name: "Banner - Street Pole",
    price: 32.95,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000179/custom-banner-500.jpg",
    brief: "Street pole outdoor banners with hardware",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "18W x 48H",
            price: 32.95,
            width: 18,
            height: 48,
            code: "18x48",
          },
          {
            name: "18W x 60H",
            price: 32.95,
            width: 18,
            height: 60,
            code: "18x60",
          },
          {
            name: "18W x 72H",
            price: 32.95,
            width: 18,
            height: 72,
            code: "18x72",
          },
          {
            name: "18W x 96H",
            price: 42.95,
            width: 18,
            height: 96,
            code: "18x96",
          },
          {
            name: "24W x 36H",
            price: 37.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "24W x 48H",
            price: 37.95,
            width: 24,
            height: 48,
            code: "24x48",
          },
          {
            name: "24W x 60H",
            price: 42.95,
            width: 24,
            height: 60,
            code: "24x60",
          },
          {
            name: "24W x 72H",
            price: 49.95,
            width: 24,
            height: 72,
            code: "24x72",
          },
          {
            name: "24W x 96H",
            price: 67.95,
            width: 24,
            height: 96,
            code: "24x96",
          },
          {
            name: "30W x 48H",
            price: 42.95,
            width: 30,
            height: 48,
            code: "30x48",
          },
          {
            name: "30W x 60H",
            price: 39.95,
            width: 30,
            height: 60,
            code: "30x60",
          },
          {
            name: "30W x 72H",
            price: 67.95,
            width: 30,
            height: 72,
            code: "30x72",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select windslits",
        options: [
          {
            name: "18oz. Blockout Without Wind Slits",
            price: 0,
            code: "no",
          },
          {
            name: "18oz. Blockout With Wind Slits",
            price: 0,
            code: "yes",
          },
        ],
      },
      addOns: {
        code: "options",
        prompt: "Select hardware",
        options: [
          {
            name: "Banner Only",
            price: 0,
            code: "banner_only",
          },
          {
            name: "Banner With Hardware",
            price: 52,
            code: "banner_with_hardware",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS0103",
  },
  {
    id: 24,
    name: "Feathered Flag - Angled",
    price: 114.95,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000179/feather_flag_v2-02_50x50.jpg",
    brief: "Dye Sublimated 4 oz polyester mesh flag material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "9 Feet",
            price: 114.95,
            width: 28,
            height: 108,
            code: "9_feet",
          },
          {
            name: "10.5 Feet",
            price: 114.95,
            width: 28,
            height: 126,
            code: "10_feet",
          },
          {
            name: "14 Feet",
            price: 124.95,
            width: 28,
            height: 168,
            code: "14_feet",
          },
        ],
      },
      addOns: {
        code: "option",
        prompt: "Select option",
        options: [
          {
            name: "Single Sided Print Thru Reverse",
            price: 0,
            code: "single_sided",
          },
          {
            name: "Double Sided",
            price: 50,
            code: "double_sided",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS0104",
  },
  {
    id: 8,
    name: "Magnetic",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/magnetic_50x50-01.jpg",
    brief: "Sticks to ferrous car doors",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "18W x 12H",
            price: 62.5,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "24W x 12H",
            price: 73.9,
            width: 24,
            height: 12,
            code: "24x12",
          },
          {
            name: "24W x 18H",
            price: 105,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 159,
            width: 24,
            height: 24,
            code: "24x24",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: ".030 mil",
            price: 0,
            code: "30_mil",
          },
        ],
      },
    },
    priceMethod: "per set",
    productCode: "CS3005",
    price: 0,
  },
  {
    id: 9,
    name: "Coroplast Yard Signs",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/coroplast_yard_sign_v2_50x50-01.jpg",
    brief: "Corrugated plastic signs for lawns",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 18H",
            price: 20,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 20,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "24W x 18H",
            price: 20.45,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 25.45,
            width: 24,
            height: 24,
            code: "24x24",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "4mil",
            price: 0,
            code: "4_mil",
          },
        ],
      },
      addOns: {
        code: "stakes",
        prompt: "Select stake",
        options: [
          {
            name: "No Stake",
            price: 0,
            code: "no_stake",
          },
          {
            name: "Wire Stakes",
            price: 1.5,
            code: "wire_stake",
          },
          {
            name: "Heavy Duty Stakes",
            price: 2.25,
            code: "heavy_duty_stake",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3001",
    price: 0,
  },
  {
    id: 10,
    name: "Vinyl",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000180/custom-truck-decal-c4-500_50x50.jpg",
    brief: "Pressure sensitive peel and paste decal",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 12H",
            price: 15.95,
            width: 12,
            height: 12,
            code: "12x12",
          },
          {
            name: "12W x 18H",
            price: 22.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 22.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "18W x 24H",
            price: 29.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 18H",
            price: 29.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 29.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 39.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 39.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "3 mil",
            price: 0,
            code: "3_mil",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS2001",
    price: 0,
  },
  {
    id: 11,
    name: "Vinyl - Vehicle Graphics",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000180/vinyl_controltac_50x50-01.jpg",
    brief: "High performance cast vinyl for vehicle graphics and wraps",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 12H",
            price: 19.95,
            width: 12,
            height: 12,
            code: "12x18",
          },
          {
            name: "12W x 18H",
            price: 19.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 19.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "18W x 24H",
            price: 29.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 18H",
            price: 29.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 39.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 59.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 59.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "36W x 36H",
            price: 89.95,
            width: 36,
            height: 36,
            code: "36x24",
          },
          {
            name: "36W x 48H",
            price: 119.95,
            width: 36,
            height: 48,
            code: "36x24",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "2 mil",
            price: 0,
            code: "2_mil",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS2002",
    price: 0,
  },
  {
    id: 12,
    name: "Vinyl - Perforated",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000180/vinyl_perforated_window_v1_50x50-01.jpg",
    brief: "Peforated graphics for windows to allow light through",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 12H",
            price: 15.95,
            width: 12,
            height: 12,
            code: "12x12",
          },
          {
            name: "12W x 18H",
            price: 15.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 15.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "18W x 24H",
            price: 15.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 18H",
            price: 15.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 15.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 29.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 29.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "36W x 36H",
            price: 44.95,
            width: 36,
            height: 36,
            code: "36x36",
          },
          {
            name: "36W x 48H",
            price: 59.95,
            width: 36,
            height: 48,
            code: "36x48",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "70/30 Perf",
            price: 0,
            code: "70_30_perforated",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS2003",
    price: 0,
  },
  {
    id: 25,
    name: "Vinyl - Clear Window Decal",
    price: 0,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000180/clear_adhesive_v1-05_50x50.jpg",
    brief: "Ultra clear vinyl with clear adhesive backing",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 12H",
            price: 15.95,
            width: 12,
            height: 12,
            code: "12x12",
          },
          {
            name: "12W x 24H",
            price: 15.95,
            width: 12,
            height: 24,
            code: "12x24",
          },
          {
            name: "18W x 24H",
            price: 22.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 24H",
            price: 29.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 44.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 44.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "36W x 36H",
            price: 68.95,
            width: 36,
            height: 36,
            code: "36x36",
          },
          {
            name: "36W x 48H",
            price: 89.95,
            width: 36,
            height: 48,
            code: "36x48",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "Single Layer Print (Day-time use)",
            price: 0,
            code: "single_layer",
          },
          {
            name: "Double Layer Print (Night-time use)",
            price: 0,
            code: "double_layer",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS2010",
  },
  {
    id: 13,
    name: "Vinyl - Reflective",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000180/vinyl_reflective_50x50-01.jpg",
    brief: "Reflects light back at night",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 12H",
            price: 19.95,
            width: 12,
            height: 12,
            code: "12x12",
          },
          {
            name: "24W x 12H",
            price: 19.95,
            width: 24,
            height: 12,
            code: "24x12",
          },
          {
            name: "24W x 24H",
            price: 39.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 59.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 59.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "36W x 36H",
            price: 89.95,
            width: 36,
            height: 36,
            code: "36x36",
          },
          {
            name: "36W x 48H",
            price: 118.95,
            width: 36,
            height: 48,
            code: "36x48",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "4 mil EG",
            price: 0,
            code: "4_mil",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS2004",
    price: 0,
  },
  {
    id: 14,
    name: "Vinyl - Wall Fabric",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000180/vinyl_wall_fabric_v1_50x50-01.jpg",
    brief: "Fabric decal material like wall paper",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 12H",
            price: 19.95,
            width: 12,
            height: 12,
            code: "12x12",
          },
          {
            name: "12W x 18H",
            price: 19.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 19.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "18W x 24H",
            price: 21.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 18H",
            price: 21.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 29.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 29.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 29.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "36W x 36H",
            price: 64.95,
            width: 36,
            height: 36,
            code: "36x36",
          },
          {
            name: "36W x 48H",
            price: 84.95,
            width: 36,
            height: 48,
            code: "36x48",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "6.5 mil",
            price: 0,
            code: "6_mil",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS2006",
    price: 0,
  },
  {
    id: 15,
    name: "Vinyl - Floor Decal",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000180/vinyl_floor_graphics_v1_50x50-01.jpg",
    brief: "Heavy duty decal material for foot traffic",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 12H",
            price: 19.95,
            width: 12,
            height: 12,
            code: "12x12",
          },
          {
            name: "12W x 18H",
            price: 19.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 19.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "12W x 24H",
            price: 24.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 24H",
            price: 47.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 72.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 72.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "7 mil",
            price: 0,
            code: "7_mil",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS2007",
    price: 0,
  },
  {
    id: 16,
    name: "Vinyl - Dry Erase",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000180/vinyl_dry_erase_50x50-01.jpg",
    brief: "Laminated decal material for dry erase markers",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 12H",
            price: 19.95,
            width: 12,
            height: 12,
            code: "12x12",
          },
          {
            name: "12W x 18H",
            price: 19.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "24W x 12H",
            price: 19.95,
            width: 24,
            height: 12,
            code: "24x12",
          },
          {
            name: "24W x 24H",
            price: 32.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 49.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 49.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
          {
            name: "36W x 36H",
            price: 74.95,
            width: 36,
            height: 36,
            code: "36x36",
          },
          {
            name: "36W x 48H",
            price: 99.95,
            width: 36,
            height: 48,
            code: "36x48",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "4 mil",
            price: 0,
            code: "4_mil",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3000",
    price: 0,
  },
  {
    id: 17,
    name: "Styrene Posters",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/styrene_50x50-01.jpg",
    brief: "Thin durable plastic poster material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 18H",
            price: 19.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 19.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "18W x 24H",
            price: 24.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 18H",
            price: 24.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 32.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 47.5,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 49.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: ".020 mil",
            price: 0,
            code: "20_mil",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3003",
    price: 0,
  },
  {
    id: 18,
    name: "PVC Signs",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/pvc_50x50-01.jpg",
    brief: "Thick heavy-duty outdoor plastic sign material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 18H",
            price: 19.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 19.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "18W x 24H",
            price: 22.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 18H",
            price: 22.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 29.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 45.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 45.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "1/8 inch",
            price: 0,
            code: "1_8_inch",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3004",
    price: 0,
  },
  {
    id: 19,
    name: "Aluminum",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/custom_aluminum_50x50-01.jpg",
    brief: "Durable rust resistant outdoor metal sign material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 18H",
            price: 24.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 24.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "18W x 24H",
            price: 39.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 18H",
            price: 39.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 36H",
            price: 79.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "040 mil",
            price: 0,
            code: "040_mil",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3006",
    price: 0,
  },
  {
    id: 20,
    name: "Foamboard",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/foamcore_v2_50x50-01.jpg",
    brief: "Paper faced foam board material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 18H",
            price: 19.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 19.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "18W x 24H",
            price: 22.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 18H",
            price: 22.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 29.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 45.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 45.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "3/16 inch",
            price: 0,
            code: "3_16_inch",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3007",
    price: 0,
  },
  {
    id: 21,
    name: "Gatorboard",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/gatorboard_50x50-01.jpg",
    brief: "Hard plastic faced foam material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 18H",
            price: 19.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 19.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "18W x 24H",
            price: 22.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 18H",
            price: 22.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 39.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 59.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 59.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "3/16 inch",
            price: 0,
            code: "3_16_inch",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3008",
    price: 0,
  },
  {
    id: 22,
    name: "Aluminum Sandwich Board",
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/alumicore_50x50-01.jpg",
    brief: "Aluminum faced plastic core sign material",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "12W x 18H",
            price: 19.95,
            width: 12,
            height: 18,
            code: "12x18",
          },
          {
            name: "18W x 12H",
            price: 19.95,
            width: 18,
            height: 12,
            code: "18x12",
          },
          {
            name: "18W x 24H",
            price: 29.95,
            width: 18,
            height: 24,
            code: "18x24",
          },
          {
            name: "24W x 18H",
            price: 29.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 39.95,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 36H",
            price: 59.95,
            width: 24,
            height: 36,
            code: "24x36",
          },
          {
            name: "36W x 24H",
            price: 59.95,
            width: 36,
            height: 24,
            code: "36x24",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "1/8 inch",
            price: 0,
            code: "1_8_inch",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3009",
    price: 0,
  },
  {
    id: 26,
    name: "Real Estate A-Frame",
    price: 0,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/real_estate_a_frame_v1-01_50x50.jpg",
    brief: "Lightweight and portable sidewalk signage",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "24W x 18H",
            price: 79.95,
            width: 24,
            height: 18,
            code: "24x18",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "4 mil Double Sided Coroplast",
            price: 0,
            code: "4_mil",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3010",
  },
  {
    id: 27,
    name: "Banner A-Frame",
    price: 0,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/banner_a_frame_v2-05_50x50.jpg",
    brief: "Aluminum A-frame with vinyl banner",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "4 Feet",
            price: 184.95,
            width: 45,
            height: 33,
            code: "4_feet",
          },
          {
            name: "8 Feet",
            price: 219.95,
            width: 94,
            height: 33,
            code: "8_feet",
          },
        ],
      },
      gauges: {
        code: "gauge",
        prompt: "Select gauge",
        options: [
          {
            name: "13oz Matte Vinyl Banner",
            price: 0,
            code: "13_oz",
          },
        ],
      },
      options: {
        code: "options",
        prompt: "Select pieces",
        options: [
          {
            name: "One Piece (Folds Over)",
            price: 0,
            code: "one_peice",
          },
          {
            name: "Two Pieces (Back-to-back)",
            price: 10,
            code: "two_peices",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3011",
  },
  {
    id: 28,
    name: "Real Estate Post and Panel",
    price: 159.95,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000216/real_estate_post_and_panel_v1-07_50x50.jpg",
    brief: "PVC post and ground stake hardware for property listings",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "24W x 18H",
            price: 0,
            width: 24,
            height: 18,
            code: "24x18",
          },
          {
            name: "24W x 24H",
            price: 4.5,
            width: 24,
            height: 24,
            code: "24x24",
          },
          {
            name: "24W x 30H",
            price: 10,
            width: 24,
            height: 30,
            code: "24x30",
          },
        ],
      },
      gauges: {
        code: "options",
        prompt: "Select options",
        options: [
          {
            name: "Doublesided Punched Holes",
            price: 0,
            code: "standard",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS3012",
  },
  {
    id: 29,
    name: "Tension Fabric Banner Stand",
    price: 194.95,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000217/tension_fabric_stand_v1_50x50.jpg",
    brief: "Dye sublimated pillowcase graphics with Stand",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "36W x 90H",
            price: 0,
            width: 36,
            height: 90,
            code: "36x90",
          },
          {
            name: "48W x 90H",
            price: 30,
            width: 48,
            height: 90,
            code: "48x90",
          },
        ],
      },
      addOns: {
        code: "option",
        prompt: "Select sides",
        options: [
          {
            name: "Single Sided",
            price: 0,
            code: "single_sided",
          },
          {
            name: "Double Sided",
            price: 30,
            code: "double_sided",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS5001",
  },
  {
    id: 30,
    name: "Economy Retractable Banner Stand",
    price: 99.95,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000217/economy_retractable_v1.jpg",
    brief: "UV printed fabric graphics with retractable stand",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "24W x 81H",
            price: 99.95,
            width: 24,
            height: 81,
            code: "24x81",
          },
          {
            name: "47W x 81H",
            price: 129.95,
            width: 47,
            height: 81,
            code: "47x81",
          },
          {
            name: "33W x 81H",
            price: 201.95,
            width: 33,
            height: 81,
            code: "33x81",
          },
        ],
      },
      addOns: {
        code: "option",
        prompt: "Select option",
        options: [
          {
            name: "No Light",
            price: 0,
            code: "no",
          },
          {
            name: "Led Light",
            price: 70,
            code: "yes",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS5002",
  },
  {
    id: 31,
    name: "Deluxe Retractable Banner Stand",
    price: 149.95,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000217/deluxe_retractable_v1_50x50.jpg",
    brief: "UV printed fabric graphic, upscale retractable stand with chrome",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "33W x 81H",
            price: 0,
            width: 33,
            height: 91,
            code: "33x91",
          },
        ],
      },
      gauge: {
        code: "gauge",
        prompt: "Select sides",
        options: [
          {
            name: "Single Sided",
            price: 0,
            code: "single_sided",
          },
          {
            name: "Double Sided",
            price: 200,
            code: "double_sided",
          },
        ],
      },
      addOns: {
        code: "option",
        prompt: "Select option",
        options: [
          {
            name: "No Light",
            price: 0,
            code: "no",
          },
          {
            name: "Led Light",
            price: 50,
            code: "yes",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS5003",
  },
  {
    id: 32,
    name: "Premium Retractable Banner Stand",
    price: 179.95,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000217/premium_retractable_v1_50x50.jpg",
    brief: "Top of the line retractable stand with chrome accents",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "36W x 69H",
            price: 179.95,
            width: 36,
            height: 69,
            code: "36x69",
          },
          {
            name: "36W x 80H",
            price: 179.95,
            width: 36,
            height: 80,
            code: "36x80",
          },
          {
            name: "36W x 92H",
            price: 179.95,
            width: 36,
            height: 92,
            code: "36x92",
          },
          {
            name: "48W x 69H",
            price: 229.95,
            width: 48,
            height: 69,
            code: "48x69",
          },
          {
            name: "48W x 80H",
            price: 229.95,
            width: 48,
            height: 80,
            code: "48x80",
          },
          {
            name: "48W x 92H",
            price: 229.95,
            width: 48,
            height: 92,
            code: "48x92",
          },
        ],
      },
      addOns: {
        code: "option",
        prompt: "LED Light",
        options: [
          {
            name: "No Light",
            price: 0,
            code: "no",
          },
          {
            name: "Led Light",
            price: 70,
            code: "yes",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS5004",
  },
  {
    id: 33,
    name: "Sign Display Table Throw",
    price: 114.95,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000217/table_throw_v1_50x50.jpg",
    brief: "Full color dye sublimated 8.8 oz. polyester fabric table covers",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "4 Feet",
            price: 114.95,
            width: 48,
            height: 30,
            code: "4_feet",
          },
          {
            name: "6 Feet",
            price: 139.95,
            width: 72,
            height: 30,
            code: "6_feet",
          },
          {
            name: "8 Feet",
            price: 159.95,
            width: 96,
            height: 30,
            code: "8_feet",
          },
        ],
      },
      addOns: {
        code: "option",
        prompt: "Select option",
        options: [
          {
            name: "3 Sided open back",
            price: 0,
            code: "3_sided",
          },
          {
            name: "4 Sided closed back",
            price: 30,
            code: "4_sided",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS5005",
  },
  {
    id: 34,
    name: "X-Stand Banner Display",
    price: 49.95,
    selectThumbnail:
      "https://www.alphabetsigns.com/mm5/graphics/00000217/x_stand_v1-14_50x50.jpg",
    brief: "Lightweight banner display easy to display",
    product_attributes: {
      sizes: {
        code: "size",
        prompt: "Select size",
        options: [
          {
            name: "24W x 63H",
            price: 49.95,
            width: 24,
            height: 63,
            code: "24x63",
          },
          {
            name: "32W x 71H",
            price: 64.95,
            width: 32,
            height: 71,
            code: "32x71",
          },
        ],
      },
    },
    priceMethod: "each",
    productCode: "CS5006",
  },
];
